import { XMarkIcon } from '@heroicons/react/20/solid';
import { connect } from 'react-redux';
import { Actions as PAYROLLACTIONS } from '../../store/actions/payrollActions';

import { useEffect, useState } from 'react';
import Spinner from '../common/Spinner';
import { format, parse } from 'date-fns';


const ResetPeriodStartModal = ({
    previousDate,
    proposedDate,
    closeModal,
    modalOpen,
    changePeriodStart,
    resettingPeriodStart
}) => {

    const [periodStart, setPeriodStart] = useState()
    useEffect(() => {
        if (previousDate) setPeriodStart(previousDate)
    }, [previousDate])

    if (!modalOpen) return null;

    return (
        <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "scroll" }}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="block block-themed block-transparent remove-margin-b" style={{ padding: 0 }}>
                        <div className="block-header bg-danger" style={{ paddingLeft: '2rem', paddingRight: '2rem' }}>
                            <ul className="block-options">
                                <li>
                                    <button className="close" type="button" aria-label="Close" onClick={() => closeModal()}><XMarkIcon className="h-6 w-6 mr-3 text-white" /></button>
                                </li>
                            </ul>
                            <h3 className="block-title">Confirm Pay Period Start Date</h3>
                        </div>
                        <div className="modal-body">
                            <p style={{ textAlign: 'center' }}>
                                When changing period start dates, all existing payslips will be deleted.
                                <br />
                                This action <strong>cannot</strong> be undone and any data deleted <strong>cannot</strong> be recovered.
                                <br />
                                <br />
                                Are you sure you'd like to change the date
                                from <strong>{format(parse(periodStart, 'yyyy-MM-dd', new Date()), 'do MMM yyyy')}</strong> to <strong>{format(parse(proposedDate, 'yyyy-MM-dd', new Date()), 'do MMM yyyy')}</strong>?
                                <div className="clearfix" />
                            </p>

                            <div className="col-xs-12">

                                <div className="col-xs-12 text-right">
                                    <button
                                        className="btn btn-default pull-left"
                                        type="button"
                                        onClick={closeModal}
                                    >Cancel</button>
                                    <button
                                        className="btn btn-danger pull-right"
                                        type="button"
                                        disabled={resettingPeriodStart}
                                        onClick={() => { changePeriodStart(proposedDate) }}
                                    >
                                        {resettingPeriodStart ?
                                            <>
                                                <Spinner
                                                    style={{ height: "1.5em", verticalAlign: 'middle', float: "left" }}
                                                    className="animate-spin -ml-1 mr-3 h-5 w-5 "
                                                />
                                                <div style={{ float: "left", paddingLeft: 5 }}>Updating...</div>
                                            </>
                                            :
                                            'Confirm'
                                        }
                                    </button>
                                </div>
                            </div>
                            <div className='clearfix' />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    const { periodStart } = { ...state.payroll.payPeriodDetails }

    return {
        previousDate: periodStart,
        modalOpen: !!state.payroll?.resetPeriodStartModal,
        proposedDate: state.payroll?.resetPeriodStartModal,
        resettingPeriodStart: state.payroll?.updatingPayPeriod
    }
}

const mapDispatchToProps = dispatch => ({
    closeModal: () => dispatch(PAYROLLACTIONS.showResetPeriodStartModal()),
    changePeriodStart: (date) => dispatch(PAYROLLACTIONS.changePeriodStart(date))
})

export default connect(mapStateToProps, mapDispatchToProps)(ResetPeriodStartModal);